import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";
import { ArtistPreview } from "components/PreviewPanel/Company/CompanyPreviewPanel";

export const RemovableArtist = (props: RemovableProps<server.dto.ArtistSmall>) => {

  return <RemovableLabel
    {...props}
  >
    <ArtistPreview
      companyId={props.value.artistId}
      trigger={<a>
        {props.value.name}
      </a>}
    />
  </RemovableLabel>;
};